// Base de todas las celdas
export const cell = {
  textAlign: 'center',
  color: '#67666A',
  fontSize: '14px',
  fontFamily: 'Open Sans',
  borderRadius: '0px',
  minHeight: '60px',
  display: 'flex',
  placeItems: 'center',
  justifyContent: 'center',
  border: 'solid 1px #E5E5E5',
  ['@media (min-width:1500px)']: {
    fontSize: '16px',
  },
};

// Celda gris general
export const grayCell = {
  ...cell,
  backgroundColor: '#EAEAEA',
  fontSize: '14px',
  fontWeight: 700,
};

// Flex columna para días
export const cellDay = {
  flexDirection: 'column',
  fontWeight: 400,
};

// Meses (subtexto)
export const cellMonths = {
  minHeight: 'initial',
  border: 'none',
};

// Celda izquierda "Ida / Vuelta"
export const borderGrayLeftCell = {
  ...grayCell,
  borderRadius: '15px 0 0 0',
  display: 'flex',
  fontSize: '16px',
};

// Días de la tabla, escritorio
export const grayGoRTCellDay = theme => ({
  ...grayCell,
  ...cellDay,
  [theme.breakpoints.down('sm')]: {
    position: 'relative',
    zIndex: 1,
  },
});

// Días de la tabla, móvil
export const grayCellDayMob = theme => ({
  ...grayCell,
  ...cellDay,
  [theme.breakpoints.down('sm')]: {
    borderRadius: '0 15px 0 0',
    position: 'relative',
    zIndex: 1,
  },
});

// Meses de la tabla
export const grayGoRTCellMonths = {
  ...grayCell,
  ...cellMonths,
};

export const grayCellMonths = { ...grayCell, ...cellMonths };

export const grayCellDay = { ...grayCell, ...cellDay };
